<div>
  <div mat-dialog-title *ngIf="holeByHole">Set Course and Date</div>
  <div mat-dialog-title *ngIf="!holeByHole">Post a Score</div>
  <form #postScoreForm="ngForm" style="width:100%">
    <div fxLayout="column" fxLayoutAlign="center stretch" fxLayoutGap="5px">
      
      <mat-button-toggle-group #roundTypeGroup="matButtonToggleGroup">
          <mat-button-toggle value="H" style="width:125px">
            Home
          </mat-button-toggle>
          <mat-button-toggle value="A" style="width:125px">
            Away
          </mat-button-toggle>
          <mat-button-toggle value="T" style="width:125px">
            Tournament
          </mat-button-toggle>
        </mat-button-toggle-group>
      <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
        <div fxFlex="20">
          Holes:
        </div>
        <mat-button-toggle-group #nbrOfHolesGroup="matButtonToggleGroup">
            <mat-button-toggle value="18" style="width:50px">
              18
            </mat-button-toggle>
            <mat-button-toggle value="9"  style="width:50px">
              9
            </mat-button-toggle>
          </mat-button-toggle-group>
        </div>
      <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
          <div fxFlex="20">
              Method:
          </div>
            <mat-button-toggle-group #entryType="matButtonToggleGroup">
              <mat-button-toggle value="pick-course"  style="width:100px">
                Pick
              </mat-button-toggle>
              <mat-button-toggle value="manual" style="width:100px">
                Manual
              </mat-button-toggle>
            </mat-button-toggle-group>
      </div>
      <mat-form-field id='date'>
          <mat-label>Date</mat-label>
          <input matInput [matDatepicker]="picker" [(ngModel)]="date" placeholder="Date"
            ng-model-options="{ timezone: 'utc' }" name='date' required>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      <mat-form-field id='pick-state'  *ngIf="entryType.value != 'manual'">
          <mat-label>State</mat-label>
          <mat-select placeholder="State" [(ngModel)]="eventState" (selectionChange)='getCourses()' name='state' required>
            <mat-option *ngFor="let state of allStates" [value]='state.state'>
              {{ state.state }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div *ngIf="entryType.value == 'manual'">
          <mat-form-field>
            <mat-label>Course Name</mat-label>
            <input matInput [(ngModel)]="course_name" placeholder="Course Name" name='course_name' required>
          </mat-form-field>
          <mat-form-field>
              <mat-label>Slope</mat-label>
              <input matInput [(ngModel)]="slope" placeholder="Slope" name='slope' required>
          </mat-form-field>
          <mat-form-field>
              <mat-label>Rating</mat-label>
              <input matInput [(ngModel)]="rating" placeholder="Rating" name='rating' required>
          </mat-form-field>
      </div>
      <div *ngIf="entryType.value != 'manual'">
        <mat-form-field id='pick-course' *ngIf="!searchingCourse">
          <mat-label>Course</mat-label>
          <mat-select placeholder="Course" [(ngModel)]="eventCourseId" (selectionChange)='getTees()' name='course'
            required>
            <mat-option *ngIf='!eventState'>Select State First</mat-option>
            <mat-option *ngFor="let course of courses" [value]='course.course_id'>
              {{ course.coursename }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div *ngIf="searchingCourse" style="height:46px;padding-top:15px">
            Getting Courses ... <i class="fa fa-spinner fa-spin"></i>
        </div>
        <mat-form-field id='pick-tees' *ngIf="!searchingTees">
          <mat-label>Tees</mat-label>
          <mat-select placeholder="Tees" [(ngModel)]="eventTeesId" name='tees' required>
            <mat-option *ngIf='!eventCourseId'>Select Course First</mat-option>
            <mat-option *ngFor="let tee of tees" [value]='tee.tees_id'>
              {{ tee.teename }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div *ngIf="searchingTees" style="height:46px;padding-top:15px">
            Getting Tees ... <i class="fa fa-spinner fa-spin"></i>
        </div>
      </div>
      <mat-form-field *ngIf="!holeByHole">
        <mat-label>Adjusted Score</mat-label>
        <input matInput [(ngModel)]="escScore" placeholder="Adjusted Score" name='score' required>
      </mat-form-field>
      <div *ngIf='error' class='warn-color'>{{error}}</div>
    </div>
    <div mat-dialog-actions fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="7px">
      <button mat-raised-button color='accent' (click)='postScore()' [disabled]="!postScoreForm.valid">
        <div *ngIf="!holeByHole && !sending">Post Score</div>
        <div *ngIf="holeByHole && !sending" fxLayout="row" fxLayoutAlign="center center">
          Continue <mat-icon>arrow_right</mat-icon>
        </div>
        <div *ngIf="sending"><i class="fa fa-spinner fa-spin"></i></div>
      </button>
      <button mat-raised-button mat-dialog-close>Nevermind</button>
    </div>
  </form>
</div>